import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router'

import Button from 'js/components/Button'
import { useSiteStore } from 'js/lib/stores'

import styles from './NavigationPortal.module.css'

const NavigationPortal = () => {
    const showLoginRegister = useSiteStore(({ site }) => site.showLoginRegister)
    const { t } = useTranslation()
    const { pathname } = useLocation()

    if (!showLoginRegister) {
        return null
    }

    return (
        <div className={styles.wrapper}>
            <Button
                size="small"
                as={Link}
                to="/login"
                state={{ next: pathname }}
            >
                {t('action.login')}
            </Button>
            <Button
                size="small"
                as={Link}
                to="/register"
                state={{ next: pathname }}
            >
                {t('action.register')}
            </Button>
        </div>
    )
}

export default NavigationPortal
